module.exports = __webpack_public_path__ + "img/GreekTechPhilosophy_ua.01b4ffef.webp";